import { BaseQueryApi } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosProgressEvent } from 'axios';
import { ENDPOINT, VEHICLES } from 'src/constants/api';
import { setUploadImageProgress } from 'src/redux/slices/inventory';

import { setHeaders } from '../base';

export const uploadImage = async (
  {
    vehicleId,
    costId,
    data,
  }: {
    vehicleId?: number;
    costId?: number;
    data: FormData;
  },
  api: BaseQueryApi
) => {
  try {
    let url = `${ENDPOINT}/${VEHICLES}`;
    if (vehicleId) {
      url = `${ENDPOINT}/${VEHICLES}/${vehicleId}/images/update`;
    }
    if (costId) {
      url = `${ENDPOINT}/attachments/add`;
    }
    // @ts-ignore
    const headers = setHeaders(new axios.AxiosHeaders(), api);
    const result = await axios.post(url, data, {
      //@ts-ignore
      headers,
      onUploadProgress: (upload: AxiosProgressEvent) => {
        if (!upload.total) return;

        const uploadloadProgress = Math.round((100 * upload.loaded) / upload.total);
        api.dispatch(setUploadImageProgress(uploadloadProgress));
      },
    });
    return { data: result.data };
  } catch (axiosError) {
    const err = axiosError;
    return {
      error: {
        //@ts-ignore
        status: err.response?.status,
        //@ts-ignore
        data: err.response?.data || err.message,
      },
    };
  }
};
